if (!customElements.get("announcement-rotator")) {
  customElements.define(
    "announcement-rotator",
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = Array.from(this.querySelectorAll(".rotating-text-item"));
        this.carousel = this.querySelector(".rotating-text-carousel");
        this.currentIndex = 0;
        this.delay = Math.max(3, Number(this.dataset.speed) || 5) * 1000;
        this.autoRotate =
          this.dataset.autoplay === "true" &&
          this.items.length > 1 &&
          !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        this.onPrevious = () => this.show(this.currentIndex - 1, true);
        this.onNext = () => this.show(this.currentIndex + 1, true);
        this.onMouseEnter = () => this.stop();
        this.onMouseLeave = () => this.start();
        this.onFocusIn = () => this.stop();
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.stop();
          else this.start();
        };

        this.querySelector("[data-announcement-previous]")?.addEventListener(
          "click",
          this.onPrevious,
        );
        this.querySelector("[data-announcement-next]")?.addEventListener(
          "click",
          this.onNext,
        );
        this.addEventListener("mouseenter", this.onMouseEnter);
        this.addEventListener("mouseleave", this.onMouseLeave);
        this.addEventListener("focusin", this.onFocusIn);
        this.addEventListener("focusout", this.onFocusOut);
        document.addEventListener("visibilitychange", this.onVisibilityChange);

        this.show(0, false);
        this.carousel?.classList.add("is-ready");
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.querySelector("[data-announcement-previous]")?.removeEventListener(
          "click",
          this.onPrevious,
        );
        this.querySelector("[data-announcement-next]")?.removeEventListener(
          "click",
          this.onNext,
        );
        this.removeEventListener("mouseenter", this.onMouseEnter);
        this.removeEventListener("mouseleave", this.onMouseLeave);
        this.removeEventListener("focusin", this.onFocusIn);
        this.removeEventListener("focusout", this.onFocusOut);
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
      }

      show(index, restart) {
        if (!this.items.length) return;
        this.currentIndex = (index + this.items.length) % this.items.length;
        this.items.forEach((item, itemIndex) => {
          const active = itemIndex === this.currentIndex;
          item.hidden = !active;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-hidden", String(!active));
        });
        if (restart) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (!this.autoRotate || document.hidden || this.timer) return;
        this.timer = window.setInterval(
          () => this.show(this.currentIndex + 1, false),
          this.delay,
        );
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    },
  );
}
